export type TicketCategory =
  | 'broken_scooter'
  | 'unlock_problem'
  | 'payment_issue'
  | 'parking'
  | 'app_bug'
  | 'other';

export type TicketStatus = 'open' | 'in_progress' | 'resolved' | 'closed';

export type TicketPriority = 'low' | 'medium' | 'high';

export interface TicketMessage {
  id?: string;
  sender: 'user' | 'admin';
  senderId: string;
  text: string;
  attachments: string[];
  createdAt: string;
}

export interface TicketMetadata {
  scooterId?: string;
  rideId?: string;
}

export interface TicketLastMessage {
  sender: 'user' | 'admin';
  senderId?: string;
  text: string;
  attachments?: string[];
  createdAt?: string;
}

export interface Ticket {
  id: string;
  userId: string;
  category: TicketCategory;
  subject: string;
  description: string;
  status: TicketStatus;
  priority: TicketPriority;
  assignedTo: string | null;
  messages?: TicketMessage[];
  lastMessage?: TicketLastMessage;
  messagesCount?: number;
  metadata?: TicketMetadata;
  createdAt: string;
  updatedAt: string;
}

export interface TicketFilters {
  status?: TicketStatus | 'all';
  category?: TicketCategory | 'all';
  priority?: TicketPriority | 'all';
  assignedTo?: string | 'me' | 'all';
  page?: number;
  limit?: number;
}

export interface TicketsPagination {
  limit: number;
  page: number;
  totalPages: number;
  count: number;
}

export const CATEGORY_LABELS: Record<TicketCategory, string> = {
  broken_scooter: 'Зламаний самокат',
  payment_issue: 'Оплата',
  unlock_problem: 'Розблокування',
  parking: 'Паркування',
  app_bug: 'Баг додатку',
  other: 'Інше',
};

export const CATEGORY_ICONS: Record<TicketCategory, string> = {
  broken_scooter: '🛴',
  payment_issue: '💳',
  unlock_problem: '🔓',
  parking: '🅿️',
  app_bug: '📱',
  other: '❓',
};

export const STATUS_LABELS: Record<TicketStatus, string> = {
  open: 'Відкритий',
  in_progress: 'В роботі',
  resolved: 'Вирішено',
  closed: 'Закритий',
};

export const PRIORITY_LABELS: Record<TicketPriority, string> = {
  low: 'Низький',
  medium: 'Середній',
  high: 'Високий',
};

export const PRIORITY_COLORS: Record<TicketPriority, string> = {
  low: '#8E8E93',
  medium: '#FF9800',
  high: '#F44336',
};

export const STATUS_COLORS: Record<TicketStatus, string> = {
  open: '#FF9800',
  in_progress: '#2196F3',
  resolved: '#4CAF50',
  closed: '#8E8E93',
};

export const QUICK_REPLIES = [
  { label: 'Привітання', text: 'Привіт! Дякуємо за звернення. Зараз допоможу вам вирішити цю проблему.' },
  { label: 'Перезапуск', text: 'Спробуйте, будь ласка, закрити додаток і відкрити знову. Якщо самокат все ще не розблоковується, вкажіть його номер — я перезапущу його віддалено.' },
  { label: 'Повернення', text: 'Я перевірив вашу поїздку. Кошти будуть повернені протягом 1-3 робочих днів на вашу картку.' },
  { label: 'Вирішено', text: 'Радий, що вдалося допомогти! Якщо виникнуть ще питання — звертайтесь. Гарного дня!' },
];
